import { IsNotEmpty, IsOptional } from "class-validator";

export class ScorePlacementDto {
  @IsNotEmpty()
  resultField: string;

  @IsOptional()
  stopWatchTimeField?: string;

  @IsOptional()
  secondsTimeField?: string;

  @IsOptional()
  jumpHeightField?: string;
}
